// extracted by mini-css-extract-plugin
module.exports = {"body":"SucessCard_body__aCB_S","icon":"SucessCard_icon__2_ai4","text":"SucessCard_text__DO75z","text2":"SucessCard_text2__2MxQT","column":"SucessCard_column__3cLFg"};